import React from 'react';
import PropTypes from 'prop-types';

const Banking = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M75.31 51.01l-51.799.428c-4.346 0-6.199-4.382-2.636-6.413l34.592-19.771a3.562 3.562 0 013.562 0L93.158 44.49"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.124 44.498c3.563 1.995 1.746 6.377-2.6 6.413h-8.016M23.477 89.207l68.328-.534M56.501 44.676a4.988 4.988 0 100-9.975 4.988 4.988 0 000 9.975zM82.508 50.982l.285 37.763M43.07 51.267l.285 37.798M69.647 51.05l.32 37.798M29.96 51.372l.286 37.798"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Banking.defaultProps = {
  className: '',
};

Banking.propTypes = {
  className: PropTypes.string,
};

export default Banking;
